var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"ads-preview scroll-content"},[_c('addMessages',{staticClass:"scroll-item",attrs:{"adCustomerAssetVo":_vm.adCustomerAssetVo}}),_vm._l((_vm.adCampaignVoList),function(item,index){return _c('structure',_vm._b({key:index},'structure',item,false))}),_c('groupNavPanel',{attrs:{"groupsForm":_vm.groupsForm}})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }